import apiClient from "../Config/Index";

const ContactApi = {
    list: async (params) => {
        try {
            const response = await apiClient.get("/admin/contact/list", { params });
            return { status: true, response: response.data };
        } catch (error) {
            console.error("Error fetching contact list:", error);
            return { status: false, response: error };
        }
    }
};

export default ContactApi;
